var render = function render(){
  var _vm$deliverySuggestio;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.$t('omt.gui.menu.label.quick-suggestion'),
      "icon": "pe-7s-compass"
    }
  }), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('b-card', {
    attrs: {
      "body-class": "pb-0"
    }
  }, [_c('b-card-title', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-primary d-inline-block mr-2",
    attrs: {
      "icon": "pen-to-square"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v(" REKEN MET ")])], 1)], 1), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.getSuggestions.apply(null, arguments);
      }
    }
  }, [_c('b-table-simple', {
    staticClass: "form-table",
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_c('tr', [_c('th', [_vm._v("Productnr")]), _c('td', [_c('b-input', {
    staticStyle: {
      "width": "115px"
    },
    attrs: {
      "type": "text",
      "size": "sm",
      "readonly": _vm.hasSuggestionResponse,
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.productIdentifier,
      callback: function ($$v) {
        _vm.$set(_vm.form, "productIdentifier", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.productIdentifier"
    }
  })], 1), _c('th'), _c('td')]), _c('tr', [_c('th', [_vm._v(" Aantal ")]), _c('td', [_c('b-input', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "size": "sm",
      "readonly": _vm.hasSuggestionResponse,
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.form, "quantity", _vm._n($$v));
      },
      expression: "form.quantity"
    }
  })], 1), _c('td', {
    staticClass: "pr-1",
    attrs: {
      "colspan": "2"
    }
  }, [!_vm.hasSuggestionResponse ? _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "type": "submit",
      "size": "sm"
    }
  }, [_vm.isProcessing ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Check")])], 1) : _c('b-button', {
    staticClass: "px-0",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.hasSuggestionResponse = false;
      }
    }
  }, [_vm._v(" wijzigen ")])], 1)])])], 1)], 1)], 1)], 1), _vm.hasSuggestionResponse ? _c('b-collapse', {
    attrs: {
      "id": "results",
      "visible": _vm.hasSuggestionResponse
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "5"
    }
  }, [_c('b-card', [_c('b-card-title', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-success d-inline-block mr-2",
    attrs: {
      "icon": "truck"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v(" BEZORGEN NAAR "), _c('a', {
    staticClass: "text-secondary editable-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.isEditZipcodeModalOpen = true;
      }
    }
  }, [_vm.form.zipcode ? _c('span', [_vm._v(_vm._s(_vm.form.zipcode))]) : _c('span', [_vm._v("POSTCODE")])]), _c('small', [_c('a', {
    staticClass: "text-secondary d-inline-block ml-2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.isEditZipcodeModalOpen = true;
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "pen-to-square"
    }
  })], 1)])])], 1)], 1), _vm.isLoadingSuggestion.delivery ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : !_vm.form.zipcode ? _c('span', [_c('i', [_vm._v("Vul de postcode in om bezorgopties te zien")])]) : _c('div', [_vm.suggestions.delivery.length ? _c('div', [_c('span', {
    staticClass: "text-dark"
  }, [_vm._v("Snelste:")]), _c('br'), _c('span', {
    staticClass: "font-size-lg"
  }, [_vm._v(_vm._s(_vm.date((_vm$deliverySuggestio = _vm.deliverySuggestion) === null || _vm$deliverySuggestio === void 0 ? void 0 : _vm$deliverySuggestio.delivery_date)))]), _c('b-button', {
    staticClass: "m-0 p-0 ml-2",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        _vm.isDeliveryDetailsModalOpen = true;
      }
    }
  }, [_c('small', [_c('font-awesome-icon', {
    staticClass: "text-info d-inline-block align-baseline",
    attrs: {
      "icon": "eye"
    }
  })], 1)])], 1) : _vm.isLoadingSuggestionError['delivery'] ? _c('span', {
    staticClass: "font-italic text-danger"
  }, [_vm._v(" Fout bij het ophalen van de bezorgopties. "), _c('b-button', {
    staticClass: "m-0 p-0 d-inline-block ml-2",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.getSuggestionForFulfillmentMethod('delivery');
      }
    }
  }, [_vm._v("probeer opnieuw")])], 1) : _c('span', {
    staticClass: "font-italic"
  }, [_vm._v(" Geen bezorgopties gevonden ")])])], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "5"
    }
  }, [_c('b-card', [_c('b-card-title', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-info d-inline-block mr-2",
    attrs: {
      "icon": "shop"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v(" AFHALEN IN DE BUURT VAN "), _c('span', {
    staticClass: "text-nowrap"
  }, [_c('a', {
    staticClass: "text-secondary editable-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.isEditPickupLocationIdentifierModalOpen = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.uppercase(_vm.getLocation(this.form.pickupLocationIdentifier).display_name)) + " ")]), _c('small', [_c('a', {
    staticClass: "text-secondary d-inline-block ml-2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.isEditPickupLocationIdentifierModalOpen = true;
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "pen-to-square"
    }
  })], 1)])])])], 1)], 1), _vm.isLoadingSuggestion.pickup ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_vm.suggestions.pickup.length ? _c('b-table-simple', {
    staticClass: "mb-0 pickup-table",
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_c('tr', [_c('th', [_vm._v("Winkel")]), _c('th', [_vm._v("Afhaaldatum")]), _c('th', [_vm._v("Voorraad")])]), _vm._l(_vm.suggestions.pickup, function (suggestion) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(suggestion.responsible_location_display_name) + " ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pickupDateToHumanText(suggestion.delivery_date)) + " ")]), _c('td', [_vm._v(" " + _vm._s(suggestion.stock_level) + " ")])]);
  })], 2) : _vm.isLoadingSuggestionError['pickup'] ? _c('span', {
    staticClass: "font-italic text-danger"
  }, [_vm._v(" Fout bij het ophalen van de afhaalopties. "), _c('b-button', {
    staticClass: "m-0 p-0 d-inline-block ml-2",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.getSuggestionForFulfillmentMethod('pickup');
      }
    }
  }, [_vm._v("probeer opnieuw")])], 1) : _c('span', {
    staticClass: "font-italic"
  }, [_vm._v(" Geen afhaalopties gevonden ")])], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-5"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "5"
    }
  }, [_c('b-card', [_c('b-card-title', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-secondary d-inline-block mr-2",
    attrs: {
      "icon": "box-open"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v(" PRODUCT INFO ")])], 1)], 1), _vm.productImage ? _c('img', {
    staticClass: "d-block my-4",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.productImage,
      "alt": ""
    }
  }) : _c('span', {
    staticClass: "font-italic"
  }, [_vm._v("Geen product info gevonden")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.deliverySuggestion ? _c('b-modal', {
    attrs: {
      "id": "delivery-details",
      "title": "Details over levering",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: _vm.isDeliveryDetailsModalOpen,
      callback: function ($$v) {
        _vm.isDeliveryDetailsModalOpen = $$v;
      },
      expression: "isDeliveryDetailsModalOpen"
    }
  }, [_c('b-table-simple', {
    staticClass: "pickup-table",
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_c('tr', [_c('th', [_vm._v("Voorraadlocatie")]), _c('td', [_vm._v(_vm._s(_vm.deliverySuggestion.responsible_location_display_name))])]), _c('tr', [_c('th', [_vm._v("Vervoerder")]), _c('td', [_vm._v(_vm._s(_vm.deliverySuggestion.carrier))])])])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "edit-zipcode",
      "title": "Wijzig postcode voor bezorging",
      "hide-footer": "",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    model: {
      value: _vm.isEditZipcodeModalOpen,
      callback: function ($$v) {
        _vm.isEditZipcodeModalOpen = $$v;
      },
      expression: "isEditZipcodeModalOpen"
    }
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.editZipcode.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "115px"
    },
    attrs: {
      "type": "text",
      "size": "sm",
      "autocomplete": "off",
      "placeholder": "1234AA",
      "maxlength": "7",
      "autofocus": ""
    },
    model: {
      value: _vm.form.zipcodeInModal,
      callback: function ($$v) {
        _vm.$set(_vm.form, "zipcodeInModal", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.zipcodeInModal"
    }
  }), _c('b-button', {
    staticClass: "d-inline-block",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "type": "submit",
      "disabled": !_vm.form.zipcodeInModal.length
    }
  }, [_vm._v("Opslaan")])], 1)]), _c('b-modal', {
    attrs: {
      "id": "edit-pickup-location",
      "title": "Wijzig afhaallocatie",
      "hide-footer": "",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    model: {
      value: _vm.isEditPickupLocationIdentifierModalOpen,
      callback: function ($$v) {
        _vm.isEditPickupLocationIdentifierModalOpen = $$v;
      },
      expression: "isEditPickupLocationIdentifierModalOpen"
    }
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.editPickupLocationIdentifier.apply(null, arguments);
      }
    }
  }, [_c('ModelSelect', {
    staticClass: "d-none d-lg-inline-block w-75 mr-2",
    attrs: {
      "options": _vm.possiblePickupLocations
    },
    model: {
      value: _vm.form.pickupLocationIdentifier,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pickupLocationIdentifier", $$v);
      },
      expression: "form.pickupLocationIdentifier"
    }
  }), _c('b-form-group', {
    staticClass: "d-block d-lg-none"
  }, _vm._l(_vm.possiblePickupLocations, function (location) {
    return _c('b-form-radio', {
      attrs: {
        "name": "pickupLocationRadio",
        "value": location.value
      },
      model: {
        value: _vm.form.pickupLocationIdentifier,
        callback: function ($$v) {
          _vm.$set(_vm.form, "pickupLocationIdentifier", $$v);
        },
        expression: "form.pickupLocationIdentifier"
      }
    }, [_vm._v(" " + _vm._s(location.text) + " ")]);
  }), 1), _c('b-button', {
    staticClass: "d-inline-block",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "type": "submit"
    }
  }, [_vm._v("Opslaan")])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }